import { HTTP } from '../http';

export default {
  namespaced: true,

  state: {
    loading: false,
    products: null,
  },

  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },

    set(state, products) {
      state.products = products;
    },
  },

  actions: {
    load({ commit }, options) {
      options = options || {};
      commit('setLoading', true);
      commit('set', null);

      if (options.category) {
        return HTTP.get('/products?category=' + encodeURIComponent(options.category))
          .then((resp) => commit('set', resp.data))
          .then(() => commit('setLoading', false))
          .catch((err) => commit('error/set', err.response, { root: true }));
      } else {
        return HTTP.get('/products')
          .then((resp) => commit('set', resp.data))
          .then(() => commit('setLoading', false))
          .catch((err) => commit('error/set', err.response, { root: true }));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/products.js